import { useState } from 'react';
import { Button, Modal } from 'antd';
import { FiCheck, FiTrash, FiTrash2 } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import './ConfirmDeleteButton.styles.css';
import type { ConfirmDeleteButtonProps } from './ConfirmDeleteButton.types.ts';

const ConfirmDeleteButton = ({
  onSubmit,
  count,
  disabled,
  title,
  isIconButton = false,
}: ConfirmDeleteButtonProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    onSubmit();
    setIsModalOpen(false);
  };

  return (
    <>
      {isIconButton ? (
        <FiTrash fontSize={18} onClick={showModal} style={{ cursor: 'pointer' }} />
      ) : (
        <Button
          disabled={Boolean(disabled)}
          icon={<FiTrash2 />}
          iconPosition="end"
          size="large"
          onClick={showModal}
        >
          {t('common.delete')}
        </Button>
      )}
      <Modal
        title={
          title ? t('modals.confirm-delete-title-2', { title }) : t('modals.confirm-delete-title')
        }
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button style={{ width: 100 }} key="back" onClick={handleCancel} size="large">
            {t('common.cancel')}
          </Button>,
          <Button
            style={{ width: 120 }}
            key="submit"
            type="primary"
            onClick={handleOk}
            icon={<FiCheck fontSize={20} />}
            iconPosition="end"
            size="large"
          >
            {t('common.confirm')}
          </Button>,
        ]}
      >
        <p>
          {title
            ? t('modals.confirm-delete-message-2', { title })
            : t('modals.confirm-delete-message', { count })}
        </p>
      </Modal>
    </>
  );
};

export default ConfirmDeleteButton;
